// extracted by mini-css-extract-plugin
export default {"error":"styles_error__g-4uB","hidden":"styles_hidden__IYvhm"};